import { NgModule } from '@angular/core';
import { RecordingsComponent } from './recordings.component';
import { RecordingsListService } from './recordings.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    CustomPipesModule,
    SvgIconModule
  ],
  providers: [
    RecordingsListService
  ],
  declarations: [
    RecordingsComponent
  ],
  exports: [
    RecordingsComponent
  ]
})
export class RecordingsModule {}
